import { Action } from 'redux'
import { isType } from 'ts-action'
import { IUpshifterLoadingReducer } from 'models/Loading'
import { SetFavoriteLoading, SetNotificationPreferenceLoading } from './actions'

export type LoadingActions = ReturnType<typeof SetFavoriteLoading>

const initialState: IUpshifterLoadingReducer = {
  favoriteLoadingIds: {},
  notificationPreferenceLoadingIds: {},
}

export const upshifterLoadingReducer = (
  state = initialState,
  action: Action,
): IUpshifterLoadingReducer => {
  if (isType(action, SetFavoriteLoading)) {
    const { payload } = action
    return {
      ...state,
      favoriteLoadingIds: {
        ...state.favoriteLoadingIds,
        [payload.id]: payload.value,
      },
    }
  }
  if (isType(action, SetNotificationPreferenceLoading)) {
    const { payload } = action
    return {
      ...state,
      notificationPreferenceLoadingIds: {
        ...state.notificationPreferenceLoadingIds,
        [payload.id]: payload.value,
      },
    }
  }
  return state
}
